import axios from "axios";

const putClinicRoom = async (baseUrl, token, doctorId, clinicId, clinicBody) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + "/doctor/" + doctorId + "/clinic/" + clinicId +  "/room", clinicBody, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return putResponse
}

export default putClinicRoom;